import { all } from 'redux-saga/effects'
import prescriptionFormSagas from '../states/prescriptionForm/sagas'

export default function* rootSaga() {
  yield all([...prescriptionFormSagas])
}
